
/**
 * Cuando se hace click en un checkbox, se procede ha marcar otro checkbox
 */
jQuery("body").on("change", ".cloneToCheckbox", function (e) {
    target = jQuery(this).attr("data-target");

    var checkbox2 = document.getElementById(target);

    // Activar checkbox2 si checkbox1 está marcado
    if ($(this).is(":checked")) {
      // Activar el checkbox2 si el checkbox1 está marcado
      $("." + target).prop("checked", true);
    } else {
      $("." + target).prop("checked", false);
    }
  });